import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from '../../services/notification.service';
import {
  Notification,
  NotificationStatus,
} from '../../models/notification.model';
import {
  faBell,
  faCircle,
  faInfoCircle,
  faCalendarCheck,
  faFileSignature,
} from '@fortawesome/free-solid-svg-icons';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'san-notification-bell',
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
  host: {
    class: 'd-inline-block',
  },
  standalone: false,
})
export class NotificationBellComponent implements OnInit {
  @ViewChild(NgbDropdown) dropdown: NgbDropdown;

  faBell = faBell;
  faCircle = faCircle;

  icons: Record<string, any> = {
    SYSTEM: faInfoCircle,
    APPOINTMENT: faCalendarCheck,
    MESSAGE: faFileSignature,
    S: faInfoCircle,
    A: faCalendarCheck,
    M: faFileSignature,
    DEFAULT: faInfoCircle,
  };

  unreadNotifications$: Observable<Notification[]>;
  unreadCount$: Observable<number>;

  constructor(
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.unreadNotifications$ = this.notificationService.notifications$.pipe(
      map((notifications) =>
        notifications.filter((n) => n.status === NotificationStatus.UNREAD),
      ),
    );
    this.unreadCount$ = this.notificationService.unreadCount$;
  }

  ngOnInit(): void {
    this.loadUnread();
  }

  loadUnread(): void {
    this.notificationService
      .loadNotifications({
        status: NotificationStatus.UNREAD,
        limit: 10,
        ordering: '-created_at',
      })
      .subscribe({
        next: () => {},
        error: () => {},
      });
  }

  markAsRead(id: string, event: Event): void {
    event.stopPropagation();
    this.notificationService.markAsRead(id).subscribe({
      next: () => {},
      error: () => {},
    });
  }

  goToOverview(): void {
    this.router.navigate(['/notifications']);
    this.dropdown?.close();
  }

  handleNotificationClick(notification: Notification): void {
    if (notification.status === NotificationStatus.UNREAD) {
      this.notificationService.markAsRead(notification.id).subscribe({
        next: () => {},
        error: () => {},
      });
    }
    this.router.navigate(['/notifications', notification.id]);
    this.dropdown?.close();
  }
}
